// extracted by mini-css-extract-plugin
module.exports = {"form":"form-module__form___3NpGx","buttonContainer":"form-module__buttonContainer___n4LDn","formInput":"form-module__formInput___2KfOx"};